export default __webpack_public_path__ + "static/media/rounded-steps.110888c2.svg";